import React, { Component } from "react";
import { Helmet } from "react-helmet";
import ProductListing from "./common/product-listing";
import "../common/index.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addToWishlist } from '../../actions/wishlist';
import { getCategoryItems } from "../../actions/category";
import { restFilters, getAllSearchFilters } from '../../actions/searchFilters';
import _ from 'lodash';
import FilterBar from './common/filter-bar';
import { toast } from 'react-toastify';


export const defaultFilter = {
  location: "all_store",
 
  page: "",
};

class Search extends Component {
  constructor() {
    super();
    this.state = {
      layoutColumns: 6,
      limit: 12,
      hasMoreItems: true,
      ...defaultFilter,
      sidebarOpen: false
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  LayoutViewClicked(colums) {
    this.setState({
      layoutColumns: colums
    })
  }


  onSetSidebarOpen(open) {
    
    if (open) {
      document.getElementById('root').style.position = "fixed";
      document.getElementById('root').style.width = "100%";
      document.getElementById('root').style.height = "100%";
    } else {
      
      document.getElementById('root').style.position = "";
      document.getElementById('root').style.height = "";
    }
    this.setState({ sidebarOpen: open });
  }
  openFilter = () => {
    document.querySelector(".collection-filter").style = "left: -15px";
  };

  componentDidMount() {
    const { connection_id, store_id } = this.props;
     if (!_.isEmpty(this.props.selectedFilters)) {
      this.props.getCategoryItems({
        ...this.state,
        ...this.props.selectedFilters,
        ...{ connection_id, store_id },
      });
    } 
    this.onSetSidebarOpen(false)
  }

  fetchMoreItems = () => {
    if (this.state.limit >= this.props.count) {
      this.setState({ hasMoreItems: false });
      return;
    }
    setTimeout(() => {
      this.setState({
        limit: this.state.limit + 12,
      });
    }, 1000);
  };

  applyFilter = (filters) => {
    // 
    const { connection_id, store_id } = this.props;
    const category_id = this.props.categoryId;
    this.props.getCategoryItems({
      ...this.state,
      category_id: filters.selectedCategories,
      brand_code: filters.selectedBrands,
      color_code: filters.selectedColors,
      gender_id: filters.selectedGenders,
      size_id: filters.selectedSizes,
      price_start_range: filters.value.min,
      price_end_range: filters.value.max,
      ...{ connection_id, category_id, store_id },
    });
    this.onSetSidebarOpen(false)
  }

  handleAddToWishlist = (item) => {
    if (this.props.isAuth) {
      const { connection_id, consumer_mobile_no } = this.props
      const options = { connection_id, consumer_mobile_no, lot_code: item.QOL_LOT_CD }
      this.props.addToWishlist(options)
  }
  else {
      toast.error("Please login / Register to add items to Wishlist.");
      this.props.history.push('/login');
  }
  }

  render() {
    const { loading } = this.props;
    // products, categoryId
    return (
      <div>
        {/*SEO Support*/}
        <Helmet>Collections
        <title>{this.props.customer_name} | Search </title>
          <meta name="description" content="" />
        </Helmet>
        {/*SEO Support End */}

        {/* <Breadcrumb title={'Collection'}/> */}

        <section className="section-b-space" style={{paddingTop:40}}>
          <div className="collection-page-title">
            {loading ? 'Searching.. please wait' : "Search Results"}
          </div>
          <div className="collection-wrapper">
            <div className="container">
              <div className="row">
                <div className="collection-content col">
                  <div className="page-main-content ">
                    <div className="">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="collection-product-wrapper">
                            <div className="" >
                              <div className="container-fluid p-0">
                                <div className="row justify-content-between">
                                  <div className="col-lg-12 d-none d-lg-inline-block" style={{ textAlign: "right" }}>
                                    <FilterBar
                                     colSize={this.state.layoutColumns}
                                     onLayoutViewClicked={(colmuns) => this.LayoutViewClicked(colmuns)} />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/*Products Listing Component*/}
                            <ProductListing
                              colSize={this.state.layoutColumns}
                              loading={this.state.loading}
                              error={this.state.error}
                              limit={this.state.limit}
                              hasMoreItems={this.state.hasMoreItems}
                              fetchMoreItems={this.fetchMoreItems}
                              addToWishlistClicked={this.handleAddToWishlist}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  // products: getVisibleproducts(state.data, state.filters),
  // products: state.category.products,
  symbol: state.data.symbol,
  categoryType: ownProps.match.params.type,
  categoryId: ownProps.match.params.id,
  loading: state.searchFilters.loading,
  error: state.searchFilters.error,
  filters: state.searchFilters,
  store_id: state.store.selectedStore && state.store.selectedStore.ASM_ASSOC_CD,
  count: state.category.count,
  connection_id: state.tenant.connection_id,
  consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
  selectedFilters: state.filters.searchSelectedFilters,
  customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
  isAuth: state.user.isAuth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCategoryItems,
      getAllSearchFilters,
      restFilters,
      addToWishlist: addToWishlist,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);
